import React from "react";
import QuestionDetail from "./QuestionDetail";

const GroupQuestionDetail = (props) => {
    const {testTypeId, question, index} = props;
    return (
        <React.Fragment>
            {question.questions.map((subQuestion, subIndex) => {
                return (
                    <QuestionDetail testTypeId={testTypeId} question={subQuestion} key={subIndex} index={index + "." + (subIndex + 1)}/>
                );

            })}
        </React.Fragment>
    );
};

export default GroupQuestionDetail;
